module.exports = __webpack_public_path__ + "static/media/asset24.caffa536.jpg";